import React from 'react';

import { IconCircleX, IconCircleCheck, IconCheck, IconX } from '@tabler/icons';
import { Container } from './styles';

import avatarImg from '../../assets/images/user-avatar.png';

interface UserItemProps {
  avatar_url?: string;
  name: string;
  description: string;
  owner?: boolean;
  needApproval?: boolean;
  canRemove?: boolean;
  onApprove?: () => void;
  onDisapprove?: () => void;
  onClick?: () => void;
  [x: string]: any;
}

const UserItem: React.FC<UserItemProps> = ({
  avatar_url,
  name,
  description,
  owner,
  needApproval,
  canRemove,
  onApprove,
  onDisapprove,
  onClick,
  ...rest
}) => {
  return (
    <Container {...rest}>
      <div
        className="left-container"
        onClick={onClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
      >
        <img
          src={avatar_url || avatarImg}
          alt="Foto"
          style={{ border: owner ? '4px solid var(--warning)' : 'none' }}
        />
        <div className="info">
          <strong>{name}</strong>
          <span>{description}</span>
        </div>
      </div>

      <div className="right-container">
        {needApproval && (
          <>
            <button onClick={onApprove} id="check-btn">
              <IconCheck size={18} />
              Aceitar
            </button>

            <button onClick={onDisapprove} id="x-btn">
              <IconX size={18} />
            </button>
          </>
        )}

        {canRemove && (
          <button onClick={onDisapprove} id="x-btn">
            <IconX size={18} />
          </button>
        )}
      </div>
    </Container>
  );
};

export default UserItem;
